import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { getTrailSuitabilityLabel, TrailSuitability } from '@alltrails/trails';
import ExploreServiceFilters from '../../types/ExploreServiceFilters';
import useCheckboxFilterConfig from './useCheckboxFilterConfig';

const suitabilities: TrailSuitability[] = ['dogs', 'kids', 'ada', 'strollers', 'paved', 'partially-paved'];

export const getValidSuitabilities = (suits: string[]) =>
  suits.filter(suit => suitabilities.includes(suit as TrailSuitability)) as TrailSuitability[];

const useSuitabilityFilterConfig = (
  exploreServiceFilters: ExploreServiceFilters,
  onFiltersChange: (updatedFilters: ExploreServiceFilters) => void,
  wheelchairLearnMoreLink: ReactNode
) => {
  const intl = useIntl();

  return useCheckboxFilterConfig({
    exploreServiceFilterKey: 'suitability',
    exploreServiceFilters,
    getValueLabel: suitability => getTrailSuitabilityLabel(intl, suitability),
    getValueSubtext: suitability => (suitability === 'ada' ? wheelchairLearnMoreLink : undefined),
    label: intl.formatMessage({ defaultMessage: 'Suitability' }),
    onFiltersChange,
    values: suitabilities
  });
};

export default useSuitabilityFilterConfig;
